import { z } from "zod";
import { SupportCasesOptionSchema } from "./support-cases-option";

export const SupportCasesProductItemSchema = SupportCasesOptionSchema.extend({
  Items: SupportCasesOptionSchema.array(),
});

export type SupportCasesProductItemType = z.infer<
  typeof SupportCasesProductItemSchema
>;
